import { withStyles } from '@material-ui/core';
import { compose } from 'ramda';

import ProductsComponent from './component';
import styles from './styles';

export default compose(withStyles(styles))(ProductsComponent);
